import { Injectable } from '@angular/core';

import { TrackingData } from '@hdms/shared/common-types';
import { DEFAULT_NAVIGATION_DATA } from '@hdms/shared/util-core';

import { ModalComponent } from './modal.component';

@Injectable()
export class ModalAnalyticsService {
  private registeredModals: ModalComponent[] = [];

  close(pageViewData: TrackingData, modal: ModalComponent): void {
    // Remove the recently closed modal instance
    this.unregister(modal);

    // Track the page view for the previously opened Modal
    if (this.registeredModals.length > 0) {
      const previousModalIndex = this.registeredModals.length - 1;
      const previousRegisteredModal = this.registeredModals[previousModalIndex];

      previousRegisteredModal.trackPageView({
        ...previousRegisteredModal.pageViewData,
        ...pageViewData
      });
    } else {
      // last modal will track the default pageView data
      modal.trackPageView({ ...modal.pageViewData, DEFAULT_NAVIGATION_DATA });
    }
  }

  registerModal(modal: ModalComponent): void {
    this.registeredModals.push(modal);
  }

  unregister(modal: ModalComponent): void {
    this.registeredModals = this.registeredModals.filter(m => m !== modal);
  }
}
